export const ERROR_MSGS = {
  INVITATION_TOKEN_MISSING:
    'The invitation token must be present, if you followed the FreeAgent invitation link and this message appeared, please contact our support team.',
  INVITATION_TOKEN_NOT_FOUND:
    'Invite token not found. If you have already created an account using this invitation link, please log in to the platform [HERE](https://app.gofreeagent.com/login).',
  UNKNOWN_ERROR:
    'Oops! Something went wrong. Please contact our support team to resolve this issue.',
};
